import React from 'react';
import { Link } from 'react-router-dom';
import { Factory, TrendingUp, Building2, CheckCircle, Circle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo, products, whyChooseUs, timeline } from '../data/mock';
import bannerImage from '../assets/banner-image.jpg';

const Home = () => {
  const getStatusIcon = (status) => {
    if (status === 'completed') return <CheckCircle className="h-6 w-6 text-[#C0D8A3]" />;
    if (status === 'in-progress') return <Circle className="h-6 w-6 text-[#C0D8A3] fill-[#C0D8A3]/50" />;
    return <Circle className="h-6 w-6 text-gray-400" />;
  };

  const getIcon = (iconName) => {
    switch(iconName) {
      case 'Factory': return <Factory className="h-10 w-10" />;
      case 'TrendingUp': return <TrendingUp className="h-10 w-10" />;
      case 'Building2': return <Building2 className="h-10 w-10" />;
      default: return <Factory className="h-10 w-10" />;
    }
  };

  return (
    <div className="min-h-screen ">
      {/* Hero Section */}
      <section
        className="relative h-[600px] md:h-[700px] flex items-center justify-center"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-[#1B4D40]/80"></div>
        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Premium Metallurgical Coke & Green Energy Solutions
            <br />
            for Industrial Excellence
          </h1>
          <p className="text-lg md:text-xl text-gray-100 mb-8 max-w-3xl mx-auto">
            Pioneering Metallurgical Coke manufacturing and Green Energy trading
            for India's steel, ferro-alloy, and foundry industries
          </p>
          {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-[#C0D8A3] hover:bg-[#27ae60] text-white font-medium px-8 py-6 text-lg transition-all hover:shadow-lg"
            >
              <Link to="/products">Explore Our Solutions</Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-white/10 hover:bg-white/20 text-white border-white font-medium px-8 py-6 text-lg backdrop-blur-sm transition-all"
            >
              <Link to="/about">Learn About Our Timeline</Link>
            </Button>
          </div> */}
        </div>
      </section>

      {/* Company Overview Section */}
      <section className="bg-[#F5F1E8] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-6 text-center">
              About Green Coke and Energy
            </h2>
            <p className="text-lg text-[#2C3E50] mb-8 leading-relaxed">
              {companyInfo.description}
            </p>
            {/* <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-[#C0D8A3] flex-shrink-0 mt-0.5" />
                  <span className="text-[#2C3E50]">
                    Specialized in Low Ash, Low Phosphorus Metallurgical Coke
                  </span>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-[#C0D8A3] flex-shrink-0 mt-0.5" />
                  <span className="text-[#2C3E50]">
                    Focus on Quality Assurance
                  </span>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-[#C0D8A3] flex-shrink-0 mt-0.5" />
                  <span className="text-[#2C3E50]">
                    Trading & Supply Chain Expertise
                  </span>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="h-6 w-6 text-[#C0D8A3] flex-shrink-0 mt-0.5" />
                  <span className="text-[#2C3E50]">
                    Commissioning Timeline: Q4 2025
                  </span>
                </div>
              </div>
            </div> */}
            <div className="text-center">
              <Button
                asChild
                variant="outline"
                className="border-[#1B4D40] text-[#1B4D40] hover:bg-[#1B4D40] hover:text-white"
              >
                <Link to="/about">Learn More About Us</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Value Props Section */}
      <section className="bg-[#1B4D40] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-white/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
                <CheckCircle className="h-8 w-8 text-[#C0D8A3]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                Quality Assured
              </h3>
              <p className="text-gray-200">
                Meeting stringent industry specifications with rigorous quality
                control processes
              </p>
            </div>
            <div className="text-center">
              <div className="bg-white/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
                <Factory className="h-8 w-8 text-[#C0D8A3]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                Industry Expertise
              </h3>
              <p className="text-gray-200">
                Deep experience in metallurgical processes and industrial supply
                chain management
              </p>
            </div>
            <div className="text-center">
              <div className="bg-white/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
                <TrendingUp className="h-8 w-8 text-[#C0D8A3]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                Reliable Supply
              </h3>
              <p className="text-gray-200">
                Consistent supply chain capabilities and dependable long-term
                partnerships
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products & Services Section */}
      {/* <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-4">
              Our Products & Services
            </h2>
            <p className="text-lg text-[#2C3E50] max-w-2xl mx-auto">
              Comprehensive solutions for your Metallurgical Coke and Green Energy
              trading needs
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {products.map((product, index) => (
              <Card
                key={index}
                className="border-2 hover:border-[#C0D8A3] transition-all hover:shadow-lg group"
              >
                <CardContent className="p-8">
                  <div className="bg-[#F5F1E8] rounded-lg w-16 h-16 flex items-center justify-center mb-6 text-[#1B4D40] group-hover:bg-[#C0D8A3] group-hover:text-white transition-colors">
                    {getIcon(product.icon)}
                  </div>
                  <h3 className="text-2xl font-bold text-[#1B4D40] mb-4">
                    {product.title}
                  </h3>
                  <p className="text-[#2C3E50] mb-6">{product.description}</p>
                  <ul className="space-y-2 mb-6">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle className="h-5 w-5 text-[#C0D8A3] flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-[#2C3E50]">
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    asChild
                    variant="outline"
                    className="w-full border-[#1B4D40] text-[#1B4D40] hover:bg-[#1B4D40] hover:text-white"
                  >
                    <Link to="/products">Learn More</Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* Why Choose Us Section */}
      {/* <section className="bg-[#1B4D40] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
            Why Choose Green Metallurgical Coke & Green Energy?
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-8"
              >
                <h3 className="text-xl font-bold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-200">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Timeline Section */}
      {/* <section className="bg-[#F5F1E8] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4D40] mb-4 text-center">
              Project Timeline & Commissioning Status
            </h2>
            <p className="text-center text-[#2C3E50] mb-12">
              Track our progress as we prepare to serve India's industrial
              sectors
            </p>

            <div className="space-y-6">
              {timeline.map((phase, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    {getStatusIcon(phase.status)}
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2">
                      <h3 className="text-lg font-bold text-[#1B4D40]">
                        {phase.phase}
                      </h3>
                      <span className="text-sm text-[#2C3E50] font-medium">
                        {phase.date}
                      </span>
                    </div>
                    <p className="text-[#2C3E50]">{phase.description}</p>
                    <span className="inline-block mt-2 text-xs font-medium px-3 py-1 rounded-full bg-white text-[#1B4D40] capitalize">
                      {phase.status === 'in-progress'
                        ? 'In Progress'
                        : phase.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <Button
                asChild
                className="bg-[#C0D8A3] hover:bg-[#27ae60] text-white"
              >
                <Link to="/contact">Stay Updated on Our Progress</Link>
              </Button>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="bg-[#C0D8A3] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Partner with Us?
          </h2>
          <p className="text-lg text-white mb-8 max-w-2xl mx-auto">
            Whether you're interested in our Metallurgical Coke products,
            trading services, or investment opportunities, we'd love to hear
            from you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              asChild
              size="lg"
              className="bg-white text-[#C0D8A3] hover:bg-gray-100 font-medium px-8"
            >
              <Link to="/contact">Request Information</Link>
            </Button>
            {/* <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#C0D8A3] font-medium px-8"
            >
              <Link to="/products">View Our Products</Link>
            </Button> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;